import module from 'viaticos/module.js'
import template from './template.html'

export class ViaticosConfiguracionEmpresaResponsablesItemComponent {
  data
  eliminando = false
  onDelete

  constructor (ViaticosProyectosProyectoResponsables) {
    this.ViaticosProyectosProyectoResponsables = ViaticosProyectosProyectoResponsables
  }

  eliminar () {
    this.eliminando = true
    this.ViaticosProyectosProyectoResponsables.delete(this.data.id_proyecto, this.data.usuario)
      .then(() => {
        this.eliminando = false
        this.onDelete()
      })
  }
}

module.component('viaticosConfiguracionEmpresaResponsablesItem', {
  controller: ViaticosConfiguracionEmpresaResponsablesItemComponent,
  template,
  bindings: {
    data: '<',
    onDelete: '&',
  },
})



// WEBPACK FOOTER //
// ./src/viaticos/components/configuracion/empresa/responsables/item/component.js